'use strict'

const operatorItem = [
  { title: 'Program', icon: 'account_box', route: '/rup/home' },
  { title: 'Kegiatan', icon: 'assignment', route: '/rup/kegiatan' },
  { title: 'Monitor Kontrak', icon: 'assignment', route: '/monitor-kontrak-divisi' },
]

const manajerItem = [
  { title: 'Program', icon: 'account_box', route: '/rup/home' },
  { title: 'Approval Kegiatan', icon: 'book', route: '/rup/kegiatan/sup' },
]

const ppkItem = [
  { title: 'Kegiatan', icon: 'book', route: '/rup/kegiatan/ppk' },
]

// const kpaItem = [
//   { title: 'Approval Kegiatan', icon: 'book', route: '/rup/kegiatan/pa' },
// ]

const paItem = [
  { title: 'Approval Kegiatan', icon: 'book', route: '/rup/kegiatan/pa' },
  { title: 'Approval Kegiatan Directorat', icon: 'book', route: '/rup/kegiatan/ppk' },
]

const operatorULPItem = [
  { title: 'Verifikasi Vendor', icon: 'dashboard', route: '/user/verifikasi' },
  { title: 'Daftar Vendor', icon: 'account_box', route: '/admin/vendor/verified' },
  { title: 'Program', icon: 'account_box', route: '/rup/home' },
  { title: 'Kegiatan', icon: 'assignment', route: '/rup/kegiatan' },
  { title: 'Seluruh Kegiatan', icon: 'assignment', route: '/rup/kegiatan/view' },
  { title: 'Paket Pengadaan', icon: 'book', route: '/rup/paket/penyedia' },
  { title: "Proses Lelang", icon: "book", route: "/ppk/tender" },
  {
    title: "Laporan",
    icon: "mdi-domain",
    route: "/monitor-report",
    child: [
      { title: "Dashboard", icon: "book", route: "/laporan-dashboard" },
      { title: "Laporan RUP dan Paket Kegiatan", icon: "book", route: "/laporan-rup-dan-paket-kegiatan" },
      { title: "Laporan Vendor", icon: "book", route: "/laporan-vendor" },
    ]
  },
  { title: "Monitor", icon: "book", route: "/monitor" },
  { title: "Monitor Ijin Usaha", icon: "book", route: "/monitor-ijin-usaha" },
  { title: "Monitor Kontrak", icon: "book", route: "/monitor-kontrak" },
  { title: "Rpt", icon: "book", route: "/rpt" },
  { title: "Kebijakan Vendor", icon: "book", route: "/setup-kebijakan-vendor" },
]

const manajerULPItem = [
  { title: 'Verifikasi Vendor', icon: 'dashboard', route: '/user/verifikasi' },
  { title: 'Daftar Vendor', icon: 'account_box', route: '/admin/vendor/verified' },
  { title: 'Program', icon: 'account_box', route: '/rup/home' },
  { title: 'Kegiatan', icon: 'assignment', route: '/rup/kegiatan' },
  { title: 'Approval Kegiatan', icon: 'book', route: '/rup/kegiatan/sup' },
  { title: 'Seluruh Kegiatan', icon: 'assignment', route: '/rup/kegiatan/view' },
  { title: 'Proses Kegiatan Konsolidasi', icon: 'book', route: '/rup/kegiatan/ulp' },
  { title: 'Paket Pengadaan', icon: 'book', route: '/rup/paket/penyedia' },
  { title: 'Approval Paket Pengadaan', icon: 'book', route: '/rup/paket/penyedia/man' },
  { title: 'Approval Jadwal Lelang', icon: 'book', route: '/ppk/approve-jadwal' },
  { title: "Proses Lelang", icon: "book", route: "/ppk/tender" },
  {
    title: "Laporan",
    icon: "mdi-domain",
    route: "/monitor-report",
    child: [
      { title: "Dashboard", icon: "book", route: "/laporan-dashboard" },
      { title: "Laporan RUP dan Paket Kegiatan", icon: "book", route: "/laporan-rup" },
      { title: "Laporan Vendor", icon: "book", route: "/laporan-vendor" },
    ]
  },
  { title: "Monitor Kontrak", icon: "book", route: "/monitor-kontrak" },
]

const adminItem = [
  { title: 'Home', icon: 'dashboard', route: '/admin' },
  { title: 'Daftar User', icon: 'account_box', route: '/admin/user' },
  { title: 'Daftar User Vendor', icon: 'account_box', route: '/admin/vendor' },
  { title: 'Paramater Aplikasi', icon: 'assignment', route: '/admin/parameter' },
  { title: 'Lokasi Proyek', icon: 'assignment', route: '/admin/lokasi-proyek' },
  { title: 'Chart of Account', icon: 'assignment', route: '/admin/coa' },
  { title: 'Divisi', icon: 'assignment', route: '/admin/divisi' },
  { title: 'Berita dan Informasi', icon: 'assignment', route: '/admin/berita-informasi' },
  { title: "Kebijakan Vendor", icon: "book", route: "/setup-kebijakan-vendor" },
]

const superItem = [
  { title: 'Home', icon: 'dashboard', route: '/super/admin' },
]

const addItem = [

  { title: 'Verifikasi Vendor', icon: 'dashboard', route: '/user/verifikasi' },
  { title: 'Program', icon: 'account_box', route: '/rup/home' },
  { title: 'Approval Kegiatan Konsolidasi', icon: 'book', route: '/rup/kegiatan/ulp' },
  { title: "[PPK] Tender", icon: "book", route: "/ppk/tender" },
  { title: "[Panitia] Paket", icon: "book", route: "/panitia/paket" },
  { title: "[Panitia] Tender", icon: "book", route: "/panitia/tender" },
]

const vendorItem = [
  { title: 'Home', icon: 'dashboard', route: '/vendor' },
  { title: 'Perusahaan', icon: 'account_box', route: '/vendor/perusahaan' },
  { title: 'Ijin Usaha', icon: 'assignment', route: '/vendor/ijin' },
  { title: 'Akta', icon: 'book', route: '/vendor/akta' },
  { title: 'Pemilik', icon: 'group', route: '/vendor/pemilik' },
  { title: 'Pengurus', icon: 'people', route: '/vendor/pengurus' },
  { title: 'Pengalaman', icon: 'local_library', route: '/vendor/pengalaman' },
  { title: 'Pajak', icon: 'payment', route: '/vendor/pajak' },
]

const personItem = [
  { title: 'Home', icon: 'dashboard', route: '/person/home' },
  { title: 'Data Pribadi', icon: 'person', route: '/person/data' },
  { title: 'Pengalaman', icon: 'local_library', route: '/person/pengalaman' },
  { title: 'Sertifikat', icon: 'book', route: '/person/sertifikat' },
];

const userHome = [
  { jenis: 'operator', path: '/rup/kegiatan', drawer: { color: 'light-blue accent-3', content: operatorItem } },
  { jenis: 'manajer', path: '/rup/kegiatan/sup', drawer: { color: 'light-blue accent-3', content: manajerItem } },
  { jenis: 'ppk', path: '/rup/kegiatan/ppk', drawer: { color: 'light-blue accent-3', content: ppkItem } },
  // { jenis: 'kpa', path: '/rup/paket/penyedia/pa', drawer: { color:'light-blue accent-3', content: kpaItem }},
  { jenis: 'pa', path: '/rup/kegiatan/pa', drawer: { color: 'light-blue accent-3', content: paItem } },
  { jenis: 'operatorULP', path: '/rup/kegiatan', drawer: { color: 'light-blue accent-3', content: operatorULPItem } },
  { jenis: 'manajerULP', path: '/rup/kegiatan/sup', drawer: { color: 'light-blue accent-3', content: manajerULPItem } },
  { jenis: 'adminit', path: '/admin', drawer: { color: 'green accent-3', content: adminItem } },
  { jenis: 'superAdmin', path: '/super/admin', drawer: { color: 'orange darken-2', content: superItem } },
  { jenis: 'vendor', path: '/vendor', drawer: { color: 'deep-purple accent-3', content: vendorItem } },
  { jenis: 'person', path: '/person/home', drawer: { color: 'teal', content: personItem } }
]

module.exports = { userHome, addItem }
